module.exports = __webpack_public_path__ + "static/media/demo.d7e8ca21.jpg";